import {Injectable} from '@angular/core';


@Injectable()
export class LastGamesService {

    constructor() {

    }



    saveGameSetUp(gameSetUp) {
        let lastGames = JSON.parse(localStorage.getItem('lastGames'));
        let currentGame = {
            gameMode: gameSetUp.gameMode,
            points: gameSetUp.points,
            sets: gameSetUp.sets,
            legs: gameSetUp.legs,
            throws: gameSetUp.throws,
            countUpRounds: gameSetUp.countUpRounds,
            teamCount: gameSetUp.teamCount
        };

        if (lastGames != null) {


            if (gameSetUp.gameMode === 'X01') {
                lastGames.x01.unshift(currentGame);

                if (lastGames.x01.length > 3) {
                    lastGames.x01 = lastGames.x01.slice(0, 3);
                }
            }
            if (gameSetUp.gameMode === 'count-up') {
                lastGames.countUp.unshift(currentGame);

                if (lastGames.countUp.length > 3) {
                    lastGames.countUp = lastGames.countUp.slice(0, 3);
                }
            }


        } else {
            if (gameSetUp.gameMode === 'X01') {
                lastGames = {
                    x01: [currentGame],
                    countUp: []
                };

                if (lastGames.x01.length > 3) {

                }
            }
            if (gameSetUp.gameMode === 'count-up') {
                lastGames = {
                    x01: [],
                    countUp: [currentGame]
                };

                if (lastGames.countUp.length > 3) {

                }
            }

        }

        localStorage.setItem('lastGames', JSON.stringify(lastGames));

        console.log(JSON.parse(localStorage.getItem('lastGames')));
    }

    loadGameSetUps() {
        if (localStorage.getItem('lastGames') != null) {
            return JSON.parse(localStorage.getItem('lastGames'));
        }
        return [];
    }

    gamesExists(gameMode) {
        if (localStorage.getItem('lastGames') != null) {
            if (gameMode === 'X01') {
                if (JSON.parse(localStorage.getItem('lastGames')).x01.length > 0) {
                    return true;
                }
            }
            if (gameMode === 'count-up') {
                if (JSON.parse(localStorage.getItem('lastGames')).countUp.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }


}



// WEBPACK FOOTER //
// ./src/app/providers/lastGames.service.ts